

























































import Vue, { PropType } from 'vue'
import { mapGetters } from 'vuex'
import { debounce } from 'debounce'
import Device from '@/services/Device'
import Person, { Phone } from '@/types/Person.interface'
import DataProviderPopup from '@/components/DataProviderPopup.vue'
export default Vue.extend({
    components: { DataProviderPopup },
    props: {
        //  The model bound to the app form
        model: {
            type: Object as PropType<Person>,
            required: true
        },
        //  Add the 'import contacts' options to the component
        withImport: {
            type: Boolean,
            default: null
        },
        //  Handles logic if this component is used in the broadcast form
        broadcastForm: {
            type: Boolean,
            default: null
        }
    },
    data() {
        return {
            duplicates: [],
            loading: false
        }
    },
    computed: {
        ...mapGetters(['appDebug', 'isApp', 'tenant']),
        canImport(): boolean {
            return this.$store.getters.userHasPermission(2)
        },
        nameIsOptional(): boolean {
            const optional =
                this.tenant.data_provider !== 'QBO' &&
                this.tenant.data_provider !== 'XERO'
            return optional
        }
    },
    methods: {
        goToDuplicate(): void {
            //  Close the app dialog
            this.$store.dispatch('dialogClose', 'APP')

            //  Get the first duplicate person
            const person = this.duplicates[0]

            //  Get the channel id so we can navigate properly
            const id = person.primary_channel_id

            //  Navigate to the duplicate
            this.$router.push(`/inbox?channel=${id}`)
        },
        importMobileContactsConfirm(): void {
            if (!this.isApp) return this.appDebug && console.log('not today bud')

            //  Inform the user that we are retrieving their contacts
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Retrieving Contacts',
                text: 'Would you like to import contacts from your mobile device? It will take some time, and we appreciate your patience.',
                callback: (result) => {
                    //  If the user answered 'NO', do nothing
                    if (!result) return

                    //  Else, import contacts from the mobile device. (why do we wait 1 sec here? ~wcv)
                    setTimeout(Device.importContacts, 1000)
                }
            })
        },
        navigate(route: string): void {
            //  Navigate to our route
            this.$router.push(route)

            //  Call our response handler
            this.onNavigation()
        },
        onNavigation(): void {
            //  If coming from broadcast from, emit submit with false
            if (this.broadcastForm) return this.$emit('submit', false)

            //  Else lets just close this dialog
            this.$store.dispatch('dialogClose', 'APP')
        },
        onNumberInput: debounce(function (phone: Phone): void {
            this.validateUniqueNumber(phone)
        }, 250),
        async submit(person: Person): Promise<void> {
            //  Validate unique phone first
            await this.validateUniqueNumber()

            //  If a duplicate was found, do nothing
            if (this.duplicates.length > 0) return

            //  Else, Validate the form
            const valid = await this.$validator.validate()

            //  If the form is NOT valid, do nothing
            if (!valid) return null

            this.loading = true

            //  Send the request to the API
            const response = await this.$store.dispatch('personsPost', person)

            this.loading = false

            //  If the request failed, do nothing
            if (!response) return null

            //  Submit the form to the parent
            this.$emit('submit', response)
        },
        async validateUniqueNumber(phone: Phone): Promise<void> {
            //  If the phone does NOT exist, do nothing
            if (!phone) return

            //  Else, check if 'standard' validation errors exist
            const hasErrors =
                this.errors.items.length > 0 &&
                this.errors.items.find(
                    (x) => x.field === 'Mobile Phone' && x.rule != 'unique_phone'
                )

            //  If the number has standard errors, no need to check for duplicates, do nothing
            if (hasErrors) return

            //  Else, remove invalid characters from the phone
            const f = this.$options.filters.phoneTrim(phone)

            //  We expect a complete number to be ten digits
            if (f.length !== 10) return

            //  Start loading since we are looking for duplicates
            this.loading = true

            //  Send the search request
            const duplicates = await this.$store.dispatch('phoneNumbersDuplicates', f)

            //  Stop loading
            this.loading = false

            //  If the request failed, no nothing
            if (!duplicates) return

            //  Else, update the duplicates array
            this.duplicates = duplicates

            //  If duplicates exist, add the validation error, else, remove the error
            if (duplicates.length > 0) {
                this.errors.add({
                    field: 'Mobile Phone',
                    msg: 'Not a unique phone',
                    rule: 'unique_phone'
                })
            } else {
                this.errors.remove('Mobile Phone', 'unique_phone')
            }
        }
    }
})
